import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const DEFAULT_TITLE = 'MLOps Specialization Course | Live Hands-on Training | Psitron Technologies'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: DEFAULT_TITLE }
  },
  {
    // Lazy-loaded: keeps the initial (home) bundle smaller
    path: '/registration',
    name: 'registration',
    component: () => import(/* webpackChunkName: "registration" */ '../views/programPlan.vue'),
    meta: { title: 'Choose Your Plan | MLOps Specialization Course | Psitron Technologies' }
  },
  {
    path: '/thankyou',
    name: 'thankyou',
    component: () => import(/* webpackChunkName: "thankyou" */ '../views/ThankYou.vue'),
    meta: { title: 'Thank You for Registering | MLOps Specialization Course' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  const title = (to.meta && to.meta.title) || DEFAULT_TITLE
  if (typeof document !== 'undefined') {
    document.title = title
  }
})

export default router
